import React from "react";
import { Download, LogOut, RefreshCw, Search } from "lucide-react";

const btn = "inline-flex items-center gap-2 px-3 py-2 text-[11px] tracking-[0.18em] uppercase font-bold transition-colors";

export const AdminHeader = ({ loading, onRefresh, onExport, onLogout }) => (
  <header className="border-b border-white/10 sticky top-0 bg-[#0F1B2D]/95 backdrop-blur z-10">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-4 flex items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        <img src="/nc-logo.png" alt="NC" className="h-9 w-auto" />
        <div className="leading-none">
          <div className="font-display tracking-[0.28em] text-sm">NORTHCREST</div>
          <div className="font-display text-[#C4A46A] tracking-[0.4em] text-[9px]">ADMIN CONSOLE</div>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <button type="button" onClick={onRefresh} disabled={loading} data-testid="admin-refresh" className={`${btn} border border-white/15 hover:border-[#C4A46A] hover:text-[#C4A46A] disabled:opacity-50`}>
          <RefreshCw size={13} className={loading ? "animate-spin" : ""} /> Refresh
        </button>
        <button type="button" onClick={onExport} data-testid="admin-export-csv" className={`${btn} bg-[#C4A46A] text-[#0F1B2D] hover:bg-[#A38755]`}>
          <Download size={13} /> Export CSV
        </button>
        <button type="button" onClick={onLogout} data-testid="admin-logout" className={`${btn} border border-white/15 hover:border-[#D96A6A] hover:text-[#D96A6A]`}>
          <LogOut size={13} /> Logout
        </button>
      </div>
    </div>
  </header>
);

export const AdminTabs = ({ tabs, active, onChange }) => (
  <div className="flex flex-wrap items-end gap-x-8 gap-y-3 border-b border-white/10">
    {tabs.map((tab) => (
      <button
        key={tab.k}
        type="button"
        onClick={() => onChange(tab.k)}
        data-testid={`admin-tab-${tab.k}`}
        className={`pb-3 -mb-px border-b-2 text-[11px] tracking-[0.24em] uppercase font-bold transition-colors ${
          active === tab.k ? "text-[#C4A46A] border-[#C4A46A]" : "text-white/60 border-transparent hover:text-white"
        }`}
      >
        {tab.label}{" "}
        <span className="ml-1 text-white/40 font-display normal-case tracking-normal">({tab.count})</span>
      </button>
    ))}
  </div>
);

export const AdminSearch = ({ q, onChange, shown, total }) => (
  <div className="mt-6 flex items-center gap-3 max-w-md" data-testid="admin-search-bar">
    <Search size={16} className="text-white/40" />
    <input
      type="search"
      value={q}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Search across all fields…"
      data-testid="admin-search-input"
      className="flex-1 bg-transparent border-0 border-b border-white/15 focus:border-[#C4A46A] focus:outline-none py-2 text-white placeholder:text-white/40 text-sm"
    />
    {q && <span className="text-[11px] text-white/50 whitespace-nowrap">{shown} / {total}</span>}
  </div>
);

export const DataTable = ({ rows, columns, testIdPrefix }) => (
  <div className="overflow-x-auto border border-white/10">
    <table className="min-w-full text-[13px]" data-testid={`${testIdPrefix}-table`}>
      <thead className="bg-white/5">
        <tr>
          {columns.map((c) => (
            <th key={c.label} className="text-left px-3 py-3 font-display text-[10px] tracking-[0.2em] uppercase text-[#C4A46A] whitespace-nowrap">{c.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.id} className="border-t border-white/10 hover:bg-white/[0.03]" data-testid={`${testIdPrefix}-row`}>
            {columns.map((c) => (
              <td key={c.label} className="px-3 py-3 text-white/85 align-top">
                <div className="max-w-[280px] whitespace-pre-wrap break-words">{String(c.get(r) ?? "")}</div>
              </td>
            ))}
          </tr>
        ))}
        {rows.length === 0 && (
          <tr>
            <td colSpan={columns.length} className="px-3 py-8 text-center text-white/50">No records.</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);
